import { setDoc } from './store';
import type { AlertaItem, Warranty } from './types';
import { alertasDosDias } from '../lib/alertasData';
import { addMonths, parseYmd, ymd } from '../lib/date';

/** Garantia legal (dias) somada à do fabricante (meses), salvo ajuste manual. */
export function warrantyEnd(w: Pick<Warranty, 'purchase' | 'legalDays' | 'months' | 'endOverride'>) {
  if (w.endOverride) return w.endOverride;
  const base = parseYmd(w.purchase);
  base.setDate(base.getDate() + w.legalDays);
  return ymd(addMonths(base, w.months));
}
/** Alertas padrão do fim da garantia (texto 10, A4): 15 e 3 dias antes, às 9h (como era antes). */
export const alertasDaGarantia: AlertaItem[] = alertasDosDias([15, 3], false);

export function daysLeft(w: Warranty, now = new Date()) {
  const hoje = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((parseYmd(warrantyEnd(w)).getTime() - hoje.getTime()) / 864e5);
}
export function saveWarranty(w: Warranty) {
  setDoc('garantias', d => ({ items: d.items.some(x => x.id === w.id) ? d.items.map(x => (x.id === w.id ? w : x)) : [...d.items, w] }));
}
export const deleteWarranty = (id: string) => setDoc('garantias', d => ({ items: d.items.filter(x => x.id !== id) }));
